// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XpsI4alPNdVf1pGr8WeN{display:flex;flex-grow:1;flex-direction:column;overflow-y:auto}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/pages/calls/ui/CallHistory/ui/mobile/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,WAAA,CACA,qBAAA,CACA,eAAA","sourcesContent":[".wrap {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `XpsI4alPNdVf1pGr8WeN`
};
export default ___CSS_LOADER_EXPORT___;
